'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = eauors;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _utils = require('../utils/');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areaUpdate(selection, accessors) {
  selection.attr({ 'data-testid': accessors.id });
}

function backgroundUpdate(selection, options, accessors) {
  selection.attr({ width: accessors.width(options), height: accessors.height(options) }).style({ fill: options.background.color });
}

function landEnter(selection, selectors) {
  (0, _utils.setupElement)(selection, 'svg:path', selectors.land);
}

function landUpdate(selection, options, accessors, projection) {
  selection.attr({
    d: _d2.default.geo.path().projection(projection)
  });
  selection.style({
    fill: accessors.areaColor(options)
  });
}

function intBoundariesEnter(selection, selectors) {
  (0, _utils.setupElement)(selection, 'svg:path', selectors.intBoundaries);
}

function intBoundariesUpdate(selection, options, accessors, projection) {
  selection.attr({
    d: _d2.default.geo.path().projection(projection)
  });
  selection.style({
    display: accessors.intBoundariesDisplay(options),
    fill: 'none',
    stroke: accessors.intBoundariesColor(options),
    'stroke-width': accessors.intBoundariesThickness(options)
  });
}

function extBoundariesEnter(selection, selectors) {
  (0, _utils.setupElement)(selection, 'svg:path', selectors.extBoundaries);
}

function extBoundariesUpdate(selection, options, accessors, projection) {
  selection.attr({
    d: _d2.default.geo.path().projection(projection)
  });
  selection.style({
    display: accessors.extBoundariesDisplay(options),
    fill: 'none',
    stroke: accessors.extBoundariesColor(options),
    'stroke-width': accessors.extBoundariesThickness(options)
  });
}

function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    areaUpdate: areaUpdate,
    backgroundUpdate: backgroundUpdate,
    landEnter: landEnter,
    landUpdate: landUpdate,
    intBoundariesEnter: intBoundariesEnter,
    intBoundariesUpdate: intBoundariesUpdate,
    extBoundariesEnter: extBoundariesEnter,
    extBoundariesUpdate: extBoundariesUpdate
  });
}